import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/Login'
import DashboardLayout from './components/layout/DashboardLayout'
import MigrationsList from './pages/MigrationsList'
import MigrationWizard from './pages/MigrationWizard'
import Migrations from './pages/Migrations'
import Servers from './pages/Servers'
import Settings from './pages/Settings'
import Emails from './pages/Emails'
import WebFiles from './pages/WebFiles'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Navigate to="migrations" replace />} />
          <Route path="migrations" element={<MigrationsList />} />
          <Route path="migrations/new" element={<MigrationWizard />} />
          <Route path="migrations/:jobId" element={<Migrations />} />
          <Route path="migrations/:jobId/:action" element={<MigrationWizard />} />
          <Route path="emails" element={<Emails />} />
          <Route path="web-files" element={<WebFiles />} />
          <Route path="servers" element={<Servers />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
